export default {
  name: 'RadioRow',
  props: {
    value: {
      type: [String, Number],
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    itemLabel: {
      default: 'label'
    },
    itemValue: {
      default: 'value'
    }
  },
  computed: {
    modelRadio: {
      get () {
        return this.value
      },
      set (newVal) {
        if (this.value !== newVal) {
          this.$emit('update:value', newVal)
        }
      }
    }
  }
}
